import { activationChecklistDismiss, activationChecklistShow, familyLinkSharesStore } from "@/api/generated";
import { mutationOptions, queryOptions, skipToken } from "@tanstack/react-query";

export const activationChecklistQueries = {
  all: () => ["activation-checklist"] as const,
  detail: (branchId: number | undefined) =>
    queryOptions({
      queryKey: [...activationChecklistQueries.all(), branchId] as const,
      queryFn:
        branchId === undefined
          ? skipToken
          : async ({ signal }) => (await activationChecklistShow({ signal })).data.data,
      // Steps change only through writes, which invalidate the checklist (see app.tsx and the mutations below).
      staleTime: 60_000,
    }),
};

export const activationChecklistMutations = {
  dismiss: () =>
    mutationOptions({
      mutationFn: () => activationChecklistDismiss(),
      meta: { invalidates: [activationChecklistQueries.all()] },
    }),
  /** Records that an administrator shared the family link; callers ignore failures so the share itself never breaks. */
  recordFamilyLinkShare: () =>
    mutationOptions({
      mutationFn: (branchId?: number) => familyLinkSharesStore({ body: branchId ? { branch_id: branchId } : {} }),
      meta: { invalidates: [activationChecklistQueries.all()] },
    }),
};
